// KPICodeAddForm.jsx
import React from "react";
import { Input, NumberInput } from '../../../../../common/Input';
import { Button } from "../../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';

export function KPICodeAddForm({
  newCodeForm,
  setNewCodeForm,
  errorState,
  onAddCode
}) {
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 mb-6">
      <h4 className="font-medium text-gray-700 text-lg mb-4">
        Add New Code
      </h4>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
        <div>
          <Input
            label="Code:"
            value={newCodeForm.code}  // ✅ Correct property name
            onChange={(e) => setNewCodeForm({ ...newCodeForm, code: e.target.value })}
            placeholder="e.g., A, B, C"  // Make sure placeholder is correct
            isRequired={true}
            error={errorState[0]?.code}
            errorMessage={errorState[0]?.code}
          />
        </div>
        <div>
          <NumberInput
            label="Rating:"
            value={newCodeForm.rating}
            onChange={(e) => setNewCodeForm({ ...newCodeForm, rating: e.target.value })}
            placeholder="Enter rating (e.g., 1, 2, 3)"
            isRequired={true}
            min="1"
            step="1"
            error={errorState[0]?.rating}
            errorMessage={errorState[0]?.rating}
          />
        </div>
        <div className="mb-4">
          <Input
            type="textarea"
            label="Description:"
            value={newCodeForm.description}
            onChange={(e) => setNewCodeForm({ ...newCodeForm, description: e.target.value })}
            placeholder="Enter description for this title"
            isRequired={true}
            rows={2}
            error={errorState[0]?.description}
            errorMessage={errorState[0]?.description}
          />
        </div>
      </div>


      <div className="flex justify-end">
        <Button
          icon={<AddIcon fontSize="small" />}
          name={"Add Code"}
          className={"bg-green-500 hover:bg-green-600 border-none cursor-pointer text-sm px-3 py-1.5"}
          onClick={onAddCode}
        />
      </div>
    </div>
  );
}